
    import {Component, Prop, Vue} from 'vue-property-decorator';
    import {Question} from '@/lib/Question';
    import Choice from "@/lib/Choice";
    import {AxiosResponse} from "axios";
    import {EntityChoice} from "@/lib/EntityChoice";

    @Component({})
    export default class VisualChoiceQuestion extends Vue {
        @Prop() public question: Question;
        public optionId?: number = 0;

        public choose(choice:any) {
            this.updateResponse(choice)
            setTimeout(() => {
                this.$emit('chosen');
            }, 500);
        }

        public isSelected(choice: Choice) {
            if (this.question.multiple) {
                const value = this.question.currentResponse!.value as string;
                return value.split(',').includes(choice.code || choice.id+'');
            }else{
                return this.optionId === choice.id;
            }
        }
        public updateResponse(option: any){
            if (this.question.multiple) {
                const valueString = this.question.currentResponse!.value as string;
                const valueArray = valueString.trim().split(',');
                const newValueArray = valueArray.includes(option.code || option.value+'') ? valueArray.filter((optionCode: string) => optionCode !== (option.code || option.value)) : valueArray.concat([option.code || option.value]);
                this.question.currentResponse!.value = newValueArray.filter((element: string) => element ).join(',');
            }else{
                this.question.currentResponse!.value = option!.code || option!.value;
                this.question.currentResponse!.valueId = option!.id;
                this.optionId = option!.id;
            }
            this.question.changedEvent.emit('changed');
            this.question.validate();


        }

        public mounted() {
            if (this.question.responseType.template === 'entity') {
                this.$store.dispatch('filterQuestion', this.question).then((response: AxiosResponse) => {
                    const data = response.data.data;

                    this.question.entityChoices = data.objects.map((result: any) => new EntityChoice(result.id, result.label));

                    const answerIsEmpty = !this.question.currentResponse || (!this.question.currentResponse.value.length && 0 === this.question.currentResponse.valueId);
                    if (!answerIsEmpty) {
                        this.optionId = this.question.currentResponse!.valueId;
                    }else{
                        if(this.question.multiple){
                            this.question.changedEvent.emit('changed');
                            this.question.validate();
                        }else{
                            if (this.question.options.length > 0) {
                                this.updateResponse(this.question.options[0]);
                            }
                        }
                    }

                });
            } else {
                const answerIsEmpty = !this.question.currentResponse || (!this.question.currentResponse.value.length && 0 === this.question.currentResponse.valueId);
                if (!answerIsEmpty) {
                    this.optionId = this.question.currentResponse!.valueId;
                }else{
                    if(this.question.multiple){
                        this.question.changedEvent.emit('changed');
                        this.question.validate();
                    }else{
                        if (this.question.options.length > 0) {
                            this.updateResponse(this.question.options[0]);
                        }
                    }


                }
            }

        }

    }
